import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useActivityReportSettingsUpdate() {
  return useFeatureSettingsUpdate('activityReport');
}
